import { School } from '../../year/school.model';
import { GradeLevelLookup } from '../../lookup/grade-level-lookup.model';
import { Year } from '../../year/year.model';


export class SelectedSite extends School {
	selected: boolean;
	GradeLevels: GradeLevelLookup[];
	Years: Year[];
	// Non DTO
	checkIndeterminate: boolean;
}
